import React, { Component, Fragment } from "react";
import { Col, Row } from 'reactstrap';
import { withStyles } from "@material-ui/core/styles";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';
import Modal from '@material-ui/core/Modal';
import ModalUI from '../../../../../shared/components/Modal';
import Autocomplete from '@material-ui/lab/Autocomplete';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormAddAlergie from "../../../../Patient/DisplayPatientInformation/components/alergies/FormAddAlergie";
import { ContinuousColorLegend } from "react-vis";


const MedicalRadio = withStyles({
    root: {
        color: '#4CE1B6',
        '&$checked': {
            color: '#4CE1B6',
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

class Pathologicals extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadedListAlergies: false,
            alergiesList: [],
            patientAlergies: [],
            openModalFormAddAlergie: false,
            alergieToForm: null,
            openAlert: false,
            modalAlert: { title: '', color: '', message: '' },
            loadedPatientAlergies: false
        }
    }

    componentDidMount() {
       /*  this.getListAlergies();
        this.getPatientAlergies(); */
    }

    getListAlergies = async () => {
        this.setState({ loadedListAlergies: true });
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'alergias-listado/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Error consultando el listado de alergias");
            }
        }).then((data) => {
            if (data.length > 0) {
                console.log("Alergias", data);
                this.setState({ loadedListAlergies: false, alergiesList: data });
            }
            else {
                this.setState({ loadedListAlergies: false, alergiesList: [] });
            }
        }).catch(err => {
            console.log(err);
            this.setState({ loadedListAlergies: false });
        });
    }

    saveAlergie = async (alergieAdd) => {
        let data = {
            nombre: alergieAdd.nombre,
            alergia_vigente: false,
            es_removible: false,
            es_uso: false,
            severidad: 0,
            reaccion: '',
            fecha: null,
            etapa: 0,
            comentario: '',
            id_historia: this.props.id_historia
        }

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'alergias/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.text();
            }
            else {
                throw new Error("Error guardando la alergia");
            }
        }).then((data) => {
            console.log("DATARESPONSE", data);
            let listAlergies = this.state.alergiesList;
            let newAlergiesList = listAlergies.filter(alergie => alergie.nombre !== alergieAdd.nombre);
            this.setState({ alergiesList: newAlergiesList });
            /* this.setState({
                openAlert: true,
                modalAlert: { message: "Guardado con exito", color: 'success', title: "Exitoso!" },
                alergiesList: newAlergiesList
            }); */
            //getPatientAlergies();
        }).catch(err => {
            console.log(err);
        });
    }

    getPatientAlergies = async () => {
        this.setState({ loadedPatientAlergies: true });
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'alergias/listar?id_historia=' + this.props.id_historia, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Error consultando las alergias del paciente");
            }
        }).then((data) => {
            let listAlergies = this.state.alergiesList;
            if (data.length > 0) {
                let newAlergiesList = [];
                listAlergies.forEach(aler => {
                    let evaluate = data.some(alg => alg.nombre === aler.nombre)
                    if (!evaluate) {
                        newAlergiesList.push(aler)
                    }
                })
                this.setState({ patientAlergies: data, alergiesList: newAlergiesList })
            }
            this.setState({ loadedPatientAlergies: false });
        }).catch(err => {
            console.log(err);
            this.setState({ loadedPatientAlergies: false });
        });
    }

    deleteAlergie = (id_alergia) => {
        let data = {
            id_alergia: id_alergia
        }
        fetch(process.env.REACT_APP_PUBLIC_URL + 'alergias/delete', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)

        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.text();
            }
            else {
                throw new Error("Error eliminando la alergia del paciente");
            }
        }).then((data) => {
            //getPatientAlergies();
            this.dropAlergieFormTexfield(this.state.alergieToForm);
        }).catch(err => {
            console.log(err);
        });
    }

    dropAlergieFormTexfield = (alergieToForm) => {
        //FieldText
        let alergiesSelectedTextField = this.state.patientAlergies;
        let newAlergies = alergiesSelectedTextField.filter((alergie) => alergie.nombre !== alergieToForm.nombre);
        this.setState({ patientAlergies: newAlergies })

        //addAlergieslist
        let listAlergies = this.state.alergiesList;
        let search = listAlergies.find(aler => aler.nombre === alergieToForm.nombre)
        if (!search) {
            listAlergies.unshift(alergieToForm);
            this.setState({ alergiesList: listAlergies })
        }
    }

    handlerAddAlergies = (alergie, reason, detail) => {
        this.setState({ patientAlergies: alergie });
        if (reason === 'select-option') {
            //this.setState({ openModalFormAddAlergie: true, alergieToForm: detail.option });
            this.saveAlergie(detail.option);
        }


        if (reason === 'remove-option') {
            this.setState({
                openAlert: true,
                modalAlert: { message: '¿Esta seguro que desea eliminar la alergia?', color: 'warning', title: 'Eliiminar!' },
                alergieToForm: detail.option
            });
        }
    }

    onOkModal = () => {
        switch (this.state.modalAlert.color) {
            case "sucess":
                this.setState({ openAlert: !this.state.openAlert });
                break;
            case "warning":
                this.deleteAlergie(this.state.alergieToForm.id_alergia);
                this.setState({ openAlert: !this.state.openAlert });
                break;
            default:
                break;
        }
    }

    handlerToCloseFormAddModal = (actionToClose) => {
        this.setState({ openModalFormAddAlergie: actionToClose })
    }

    render() {
        return (
            <Fragment>
                <Row>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Hipertensión</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerPathologicalBackgroundRadio(e.target.value, 'hipertension');
                                        }}
                                        row aria-label="position"
                                        id="radio-pato-hipertension"
                                        name="radio-pato-hipertension"
                                        value={this.props.sectionAilment.pathologicals.hipertension.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.pathologicals.hipertension.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.pathologicals.hipertension.comentario}
                                    onChange={(e) => {
                                        this.props.handlerPathologicalBackgroundText(e.target.value, 'hipertension');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Diabetes</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerPathologicalBackgroundRadio(e.target.value, 'diabetes');
                                        }}
                                        row aria-label="position"
                                        id="radio-pato-diabetes"
                                        name="radio-pato-diabetes"
                                        value={this.props.sectionAilment.pathologicals.diabetes.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.pathologicals.diabetes.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.pathologicals.diabetes.comentario}
                                    onChange={(e) => {
                                        this.props.handlerPathologicalBackgroundText(e.target.value, 'diabetes');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>

                </Row>
                {/*  // hiperlipidemia, enfermedad_coronaria, enf_vascular_per, hepatitis */}
                <Row>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Hiperlipidemia</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerPathologicalBackgroundRadio(e.target.value, 'hiperlipidemia');
                                        }}
                                        row aria-label="position"
                                        id="radio-pato-hiperlipidemia"
                                        name="radio-pato-hiperlipidemia"
                                        value={this.props.sectionAilment.pathologicals.hiperlipidemia.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.pathologicals.hiperlipidemia.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.pathologicals.hiperlipidemia.comentario}
                                    onChange={(e) => {
                                        this.props.handlerPathologicalBackgroundText(e.target.value, 'hiperlipidemia');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Enf. Coronaria</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerPathologicalBackgroundRadio(e.target.value, 'enfermedad_coronaria');
                                        }}
                                        row aria-label="position"
                                        id="radio-pato-enfermedad_coronaria"
                                        name="radio-pato-enfermedad_coronaria"
                                        value={this.props.sectionAilment.pathologicals.enfermedad_coronaria.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.pathologicals.enfermedad_coronaria.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.pathologicals.enfermedad_coronaria.comentario}
                                    onChange={(e) => {
                                        this.props.handlerPathologicalBackgroundText(e.target.value, 'enfermedad_coronaria');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Enf. Vascular Periferica</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerPathologicalBackgroundRadio(e.target.value, 'enf_vascular_per');
                                        }}
                                        row aria-label="position"
                                        id="radio-pato-enf_vascular_per"
                                        name="radio-pato-enf_vascular_per"
                                        value={this.props.sectionAilment.pathologicals.enf_vascular_per.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.pathologicals.enf_vascular_per.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.pathologicals.enf_vascular_per.comentario}
                                    onChange={(e) => {
                                        this.props.handlerPathologicalBackgroundText(e.target.value, 'enf_vascular_per');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Hepatitis</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerPathologicalBackgroundRadio(e.target.value, 'hepatitis');
                                        }}
                                        row aria-label="position"
                                        id="radio-pato-hepatitis"
                                        name="radio-pato-hepatitis"
                                        value={this.props.sectionAilment.pathologicals.hepatitis.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.pathologicals.hepatitis.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.pathologicals.hepatitis.comentario}
                                    onChange={(e) => {
                                        this.props.handlerPathologicalBackgroundText(e.target.value, 'hepatitis');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Cancer</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerPathologicalBackgroundRadio(e.target.value, 'cancer');
                                        }}
                                        row aria-label="position"
                                        id="radio-pato-cancer"
                                        name="radio-pato-cancer"
                                        value={this.props.sectionAilment.pathologicals.cancer.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.pathologicals.cancer.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.pathologicals.cancer.comentario}
                                    onChange={(e) => {
                                        this.props.handlerPathologicalBackgroundText(e.target.value, 'cancer');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Transfusiones</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerPathologicalBackgroundRadio(e.target.value, 'transfusiones');
                                        }}
                                        row aria-label="position"
                                        id="radio-pato-transfusiones"
                                        name="radio-pato-transfusiones"
                                        value={this.props.sectionAilment.pathologicals.transfusiones.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.pathologicals.transfusiones.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.pathologicals.transfusiones.comentario}
                                    onChange={(e) => {
                                        this.props.handlerPathologicalBackgroundText(e.target.value, 'transfusiones');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
                {/* <Row>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Infecciosos</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerPathologicalBackgroundRadio(e.target.value, 'infecciosos');
                                        }}
                                        row aria-label="position"
                                        id="radio-pato-infecciosos"
                                        name="radio-pato-infecciosos"
                                        value={this.props.sectionAilment.pathologicals.infecciosos.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.pathologicals.infecciosos.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.pathologicals.infecciosos.comentario}
                                    onChange={(e) => {
                                        this.props.handlerPathologicalBackgroundText(e.target.value, 'infecciosos');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Traumaticos</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerPathologicalBackgroundRadio(e.target.value, 'traumatico');
                                        }}
                                        row aria-label="position"
                                        id="radio-pato-traumatico"
                                        name="radio-pato-traumatico"
                                        value={this.props.sectionAilment.pathologicals.traumatico.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.pathologicals.traumatico.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.pathologicals.traumatico.comentario}
                                    onChange={(e) => {
                                        this.props.handlerPathologicalBackgroundText(e.target.value, 'traumatico');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Cardiacos</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerPathologicalBackgroundRadio(e.target.value, 'cardiacos');
                                        }}
                                        row aria-label="position"
                                        id="radio-pato-cardiacos"
                                        name="radio-pato-cardiacos"
                                        value={this.props.sectionAilment.pathologicals.cardiacos.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.pathologicals.cardiacos.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.pathologicals.cardiacos.comentario}
                                    onChange={(e) => {
                                        this.props.handlerPathologicalBackgroundText(e.target.value, 'cardiacos');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Vasculares</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerPathologicalBackgroundRadio(e.target.value, 'vasculares');
                                        }}
                                        row aria-label="position"
                                        id="radio-pato-vasculares"
                                        name="radio-pato-vasculares"
                                        value={this.props.sectionAilment.pathologicals.vasculares.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.pathologicals.vasculares.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.pathologicals.vasculares.comentario}
                                    onChange={(e) => {
                                        this.props.handlerPathologicalBackgroundText(e.target.value, 'vasculares');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                </Row> */}
                {/* <Row>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Autoinmunes</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerPathologicalBackgroundRadio(e.target.value, 'autoinmunes');
                                        }}
                                        row aria-label="position"
                                        id="radio-pato-autoinmunes"
                                        name="radio-pato-autoinmunes"
                                        value={this.props.sectionAilment.pathologicals.autoinmunes.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.pathologicals.autoinmunes.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.pathologicals.autoinmunes.comentario}
                                    onChange={(e) => {
                                        this.props.handlerPathologicalBackgroundText(e.target.value, 'autoinmunes');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Alergicos</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerPathologicalBackgroundRadio(e.target.value, 'alergicos');
                                        }}
                                        row aria-label="position"
                                        id="radio-pato-alergicos"
                                        name="radio-pato-alergicos"
                                        value={this.props.sectionAilment.pathologicals.alergicos.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                {/* <TextField
                                        label=""
                                        disabled={this.props.sectionAilment.pathologicals.alergicos.value == "No"  || this.props.stateClinicHistory == true ? true : false}
                                        value={this.props.sectionAilment.pathologicals.alergicos.comentario}
                                        onChange={(e) => {
                                            this.props.handlerPathologicalBackgroundText(e.target.value, 'alergicos');
                                        }}
                                        style={{ minWidth: '100%', maxWidth: '100%' }}
                                        className="medical-material-form__field"
                                        InputLabelProps={{
                                            //style: { color: '#646777' }
                                        }}
                                    /> 

                                <FormControl
                                    style={{ width: '100%' }}
                                /* error={errors.hasOwnProperty("patientAlergies") ? errors.patientAlergies !== "" : false} 
                                >
                                    <Autocomplete
                                        multiple
                                        id="tags-standard"
                                        style={{ width: '100%' }}
                                        options={this.state.alergiesList}
                                        value={this.state.patientAlergies}
                                        getOptionLabel={(option) => option.nombre}
                                        disabled={this.props.sectionAilment.pathologicals.alergicos.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                        onChange={(event, value, reason, detail) => {
                                            console.log("evento", event, "valor", value, "reason", reason, "detail", detail);
                                            this.handlerAddAlergies(value, reason, detail);
                                        }}
                                        renderInput={(params) => {
                                            console.log("WhatParams", params)
                                            return (<TextField
                                                {...params}
                                                variant="standard"
                                                label=""
                                                placeholder="Alergia"
                                                className='text-field-autocomplete'
                                            />)
                                        }}
                                    />
                                    {/* <FormHelperText>{errors.patientAlergies}</FormHelperText> 
                                </FormControl>
                            </div>
                        </div>
                    </Col>
                </Row> */}
                {/* <Row>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Hospitalarios</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerOthersBackgroundRadio(e.target.value, 'hospitalario');
                                        }}
                                        row aria-label="position"
                                        id="radio-others-hospitalario"
                                        name="radio-others-hospitalario"
                                        value={this.props.sectionAilment.others.hospitalario.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.others.hospitalario.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.others.hospitalario.comentario}
                                    onChange={(e) => {
                                        this.props.handlerOthersBackgroundText(e.target.value, 'hospitalario');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Psiquiatricos</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerOthersBackgroundRadio(e.target.value, 'psiquiatricos');
                                        }}
                                        row aria-label="position"
                                        id="radio-others-psiquiatricos"
                                        name="radio-others-psiquiatricos"
                                        value={this.props.sectionAilment.others.psiquiatricos.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.others.psiquiatricos.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.others.psiquiatricos.comentario}
                                    onChange={(e) => {
                                        this.props.handlerOthersBackgroundText(e.target.value, 'psiquiatricos');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black', position: 'absolute', width: '300px' }} disabled={true}>{'Enfermedades de Transmisión Sexual'}</FormLabel>
                                    <FormLabel style={{ color: 'black' }} disabled={true}>&nbsp;</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerOthersBackgroundRadio(e.target.value, 'enfermades_t_sexual');
                                        }}
                                        row aria-label="position"
                                        id="radio-others-enfermades_t_sexual"
                                        name="radio-others-enfermades_t_sexual"
                                        value={this.props.sectionAilment.others.enfermades_t_sexual.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.others.enfermades_t_sexual.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.others.enfermades_t_sexual.comentario}
                                    onChange={(e) => {
                                        this.props.handlerOthersBackgroundText(e.target.value, 'enfermades_t_sexual');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Metabólicos</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerPathologicalBackgroundRadio(e.target.value, 'metabolicos');
                                        }}
                                        row aria-label="position"
                                        id="radio-pato-metabolicos"
                                        name="radio-pato-metabolicos"
                                        value={this.props.sectionAilment.pathologicals.metabolicos.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.pathologicals.metabolicos.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.pathologicals.metabolicos.comentario}
                                    onChange={(e) => {
                                        this.props.handlerPathologicalBackgroundText(e.target.value, 'metabolicos');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                </Row> */}

                <br />
                <div className="form">
                    <span className="form__form-group-label" style={{ marginRight: 10, width: 150 }}>Observaciones</span>
                    <div className="form__form-group-field">
                        <textarea
                            disabled={this.props.stateClinicHistory}
                            id="textarea-observation"
                            value={this.props.sectionAilment.pathologicals.observacion}
                            name="textarea-receipt"
                            onChange={(e) => {
                                this.props.handlerPathologicsObservation(e.target.value, 'observacion');
                            }}
                        >
                        </textarea>
                    </div>
                </div>
                {this.state.openModalFormAddAlergie == true ?
                    <Fragment>
                        <Modal
                            open={this.state.openModalFormAddAlergie}
                            /* onClose={() => {
                                setOpenModalFormAddAlergie(false);
                            }} */
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            style={{ zIndex: 1000 }}
                        >
                            <div className="paperAppointment-flex" style={{ borderColor: 'white', boxShadow: 'white', height: '300x', width: '80%', margin: 10 }}>
                                <FormAddAlergie id_historia={this.props.id_historia} alergieToForm={this.state.alergieToForm} setOpenModalFormAddAlergie={this.handlerToCloseFormAddModal} dropAlergieFormTexfield={this.dropAlergieFormTexfield} />
                            </div>
                        </Modal>
                    </Fragment>
                    : null
                }
                {
                    this.state.openAlert ?
                        <ModalUI
                            color={this.state.modalAlert.color
                            }
                            title={this.state.modalAlert.title}
                            message={this.state.modalAlert.message}
                            modal={this.state.openAlert}
                            toggle={() => { this.setState({ openAlert: !this.state.openAlert }, () => this.getPatientAlergies()) }}
                            onOk={() => this.onOkModal()}
                        /> : null}
            </Fragment>
        );
    }
}

export default Pathologicals;
